import { Layout } from "@/components";
import { BookingCheck, BookingConfirm, Complete, CompleteMobile, Home, Payment, Reserve } from "@/domains";
import { MEDIA } from "@/styles/common";
import { createBrowserRouter, Navigate } from "react-router-dom";

const router = () => {
    const { isTablet } = MEDIA();
    const defaultParams = new URLSearchParams(window.location.search).get("co_id");

    return createBrowserRouter([
        {
            path: "/",
            element: <Layout />,
            children: [
                {
                    path: "/",
                    element: (
                        <Navigate
                            to={isTablet ? `/reserve?co_id=${defaultParams}` : `/status?co_id=${defaultParams}`}
                            replace
                        />
                    ),
                },
                {
                    path: "/status",
                    element: isTablet ? <Navigate to={`/reserve?co_id=${defaultParams}`} replace /> : <Home />,
                },
                {
                    path: "/reserve",
                    element: <Reserve />,
                },
                {
                    path: "/payment",
                    element: <Payment />,
                },
                {
                    path: "/bookingCheck",
                    element: <BookingCheck />,
                },
                {
                    path: "/complete",
                    element: <Complete />,
                },
                {
                    path: "/completeMobile",
                    element: <CompleteMobile />,
                },
                {
                    path: "/bookingConfirm",
                    element: <BookingConfirm />,
                },
            ],
        },
    ]);
};

export default router;
